export const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
}